import { ChildProgramComponentInput } from "@/graphql";
import { ParticipantComponent } from "@/types/programs";

export type ComponentWithDate = Pick<
  ParticipantComponent | ChildProgramComponentInput,
  "targetStartDate" | "name"
>;

const dateComparator = (a: ComponentWithDate, b: ComponentWithDate) => {
  const dateA = a.targetStartDate
    ? new Date(a.targetStartDate).getTime()
    : Number.POSITIVE_INFINITY;
  const dateB = b.targetStartDate
    ? new Date(b.targetStartDate).getTime()
    : Number.POSITIVE_INFINITY;
  // First sort by date
  const dateComparison = dateA - dateB;

  if (dateComparison !== 0) {
    return dateComparison;
  }

  // If dates are equal, sort by name
  const nameA = a.name || "";
  const nameB = b.name || "";

  return nameA.localeCompare(nameB);
};

export const sortComponentsByDate = <
  T extends ParticipantComponent | ChildProgramComponentInput,
>(
  components: T[],
): T[] => {
  return [...components].sort(dateComparator);
};
